import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

export const getEditorZDColumns = (
  t: TFunction,
  options: string[],
  selectedService: string,
  periodModel: string[]
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`editorZD.${selectedService}.${option}`),
      dataIndex: option,
      key: option,
    };

    // Special render for fields with period
    if (periodModel && periodModel.includes(option)) {
      return {
        ...baseColumn,
        render: (value: any, record: any) => {
          const periodValue = record[option + "Period"];
          return (
            <div>
              <span>{value}</span>
              {periodValue && (
                <div style={{ fontSize: "11px", color: "#888" }}>
                  {periodValue}
                </div>
              )}
            </div>
          );
        },
      };
    }

    // Default render
    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
